import { Box, CircularProgress, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material'
import BackNavigationHeader, { BackNavigationContent } from 'components/BackNavigationHeader'
import { ArrowBackIosNew } from '@mui/icons-material'
import { FC } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useOfferListOffer } from 'services/offer/hooks/useOfferList'
import 'react-image-gallery/styles/css/image-gallery.css'
import OfferDetailsView from './OfferDetailsView'
import { UserProtectedRoute } from 'routes'

// Offer detail ("Panel Klienta 3.0" Oferty).
const OfferDetails: FC = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))
  const { data: offerDetail = [], isFetching, isLoading } = useOfferListOffer(id)

  if (isFetching || isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress />
      </Box>
    )
  }

  return (
    <>
      <BackNavigationHeader navigateTo='/offer' label={offerDetail.flat.address} />
      <UserProtectedRoute>
        <BackNavigationContent sx={{ position: 'relative', paddingBottom: '20px' }}>
          {isDesktop && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', mb: '16px' }}>
              <IconButton size='small' onClick={() => navigate('/offer')}>
                <ArrowBackIosNew sx={{ fontSize: '16px', color: theme.r4r.navy }} />
              </IconButton>
              <Typography sx={{ fontSize: '18px', fontWeight: 700, color: theme.r4r.navy }}>
                {offerDetail.flat.address}
              </Typography>
            </Box>
          )}
          <OfferDetailsView />
        </BackNavigationContent>
      </UserProtectedRoute>
    </>
  )
}

export default OfferDetails
